import { render, staticRenderFns } from "./WorkflowChange.vue?vue&type=template&id=190387d1&scoped=true"
import script from "./WorkflowChange.vue?vue&type=script&lang=ts"
export * from "./WorkflowChange.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190387d1",
  null
  
)

export default component.exports